import logo from '../images/logo.svg'
// import logoPride from '../images/logo_pride.svg'

const Globals = {
  isInternal: function (link) {
    return !link.startsWith("http")
  },
  classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  },
  currentLogo() {
    return logo;
    // let now = new Date().getMonth()
    // if (now === 5) {
    //   return logoPride;
    // } else {
    //   return logo;
    // }
  },
  tabClass: function(selected) {
    return (selected ? 'border-2 border-blue-500' : 'shadow text-navyBlue hover:bg-gray-100 border border-transparent') + ' inline-flex items-center px-4 py-2 shadow-sm text-base font-medium rounded-md bg-gray-tabBackground focus:outline-none'
  }
}

export default Globals
